export type ReportsOperacionAnchor = 'tesoreria';

export type ReportsNavigationIntent = {
  section?: 'resumen' | 'ventas' | 'personal' | 'operacion' | 'compras' | 'agenda';
  operacionAnchor?: ReportsOperacionAnchor;
};

let pendingIntent: ReportsNavigationIntent | null = null;

export function setReportsNavigationIntent(intent: ReportsNavigationIntent): void {
  pendingIntent = intent;
}

export function consumeReportsNavigationIntent(): ReportsNavigationIntent | null {
  const intent = pendingIntent;
  pendingIntent = null;
  return intent;
}
